module.exports = __webpack_public_path__ + "static/media/mail.e86da1ca.svg";